import { infoPresentersRegister } from 'plugin-aeapps-resources-manager/shared/api/InfoPresentersRegister'

import { mappedChannelsPresenter } from './MappedChannelsResourceInfo'

infoPresentersRegister.addInfoPresenter(mappedChannelsPresenter)
console.log(infoPresentersRegister)
